import { makeStyles } from '~styles';
import { ifFeature } from '@bamboohr/utils/lib/feature';

export const useStyles = makeStyles()(() => {
	return {
		root: {
			boxSizing: 'border-box',
			flexGrow: 1,
			overflowY: 'auto',
			padding: ifFeature('encore', '18px 24px', '24px'),
		},
	};
});
